import React from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import moment from "moment";
import store from "../../../../store/store";
import styled from "styled-components";
import CryptoJS from "crypto-js";
import { ReactComponent as copyIcon } from "../../../../assets/icons/copy.svg";
import { SvgIcon, Box, Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton/";
import Icon from "@material-ui/core/Icon/";
import toggleOnIcon from "../../../../assets/icons/icon-toggle-on.svg";
import toggleOffIcon from "../../../../assets/icons/icon-toggle-off.svg";

const initialState = {};
const dateTimeFormat = "DD/MM/YYYY";

const Button = styled.button`
	position: relative;
	width: 120px;
	padding: 14px 0;
	margin: 0;
	font-family: "Maison Neue Bold", sans-serif;
	font-weight: normal;
	font-size: 14px;
	line-height: 150%;
	text-transform: uppercase;
	background: #fff;
	margin-right: 0px;
	border-radius: 4px;
	color: ${({ color }) => (color ? color : "#4D4C4D")};
	border: ${({ color }) =>
		color ? `1px solid ${color}` : "1px solid #4D4C4D"};

	&:disabled {
		background: #807e80;
		border-color: ${({ color }) => (color ? "#807E80" : "#4D4C4D88")};
	}

	${({ variant }) =>
		variant === "primary" &&
		`
    background: #9036F7;
    color: white;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 0px;
    `};
`;

export default class ApikeysForm extends React.Component {
	constructor(props) {
		super(props);

		const { auth } = store.getState();

		this.state = {
			id: 0,
			service: "",
			key: this.getKey(),
			expiresAt: moment(new Date()).format(dateTimeFormat),
			isLoading: false,
			isEditing: false,
			userLogged: auth.user,
			isEdit: false,
			apiData: {},
			showTooltip: false,
			isIndefinite: false
		};

		this.api = new MutantApiService();

		this.handleChange = this.handleChange.bind(this);
		this.onCleanForm = this.onCleanForm.bind(this);
		this.submit = this.submit.bind(this);
		this.generateKey = this.generateKey.bind(this);
		this.getKey = this.getKey.bind(this);
	}

	async generateKey() {
		const key = this.getKey();
		this.setState({ key });
	}

	toggleTooltip = () => {
		this.setState({ showTooltip: true }, () => {
			setTimeout(() => {
				this.setState({ showTooltip: false });
			}, 1000);
		});
	};

	getKey() {
		return CryptoJS.lib.WordArray.random(100).toString();
	}

	async componentDidMount() {
		const isEditing = !!this.props.match.params.id;
		this.setState({ isLoading: true, isEditing });
		try {
			if (this.props.match.params.id) {
				await this.loadData(this.props.match.params.id);
			}
		} catch (error) {
			await Swal.fire(
				"Erro!",
				"Ocorreu um erro ao carregar os dados, tente novamente mais tarde!",
				"error"
			);
		}

		this.setState({ isLoading: false });
	}

	loadData = async id => {
		const apikey = await this.api.makeHttpRequest({
			url: `/apikey/${id}`
		});
		this.setState({
			id: id,
			service: `${apikey.service}`,
			key: `${apikey.key}`,
			expiresAt: moment(
				apikey.expiresAt ? apikey.expiresAt : new Date()
			).format(dateTimeFormat),
			isIndefinite: apikey.isIndefinite,
			isLoading: false,
			isEdit: true,
			apiData: apikey
		});
	};

	submit = async e => {
		e.preventDefault();

		const id = this.props.match.params.id;
		this.setState({ isLoading: true });
		try {
			const reqBase = id
				? { method: "PATCH", url: `/apikey/${id}` }
				: { method: "POST", url: "/apikey" };

			await this.api.makeHttpRequest({
				...reqBase,
				data: {
					...this.state.apiData,
					service: this.state.service,
					key: this.state.key,
					isIndefinite: this.state.isIndefinite,
					expiresAt: moment(this.state.expiresAt, dateTimeFormat).toDate() // Convertendo para Date aqui
				}
			});

			this.afterSubmit();
		} catch (e) {
			Swal.fire(
				"Erro!",
				e?.response?.data
					? e.response.data.message
					: "Erro ao cadastrar cliente, tente novamente mais tarde.",
				"error"
			);
		}

		this.setState({ isLoading: false });
	};

	afterSubmit = async () => {
		this.setState({
			...initialState,
			resetInput: true
		});

		await Swal.fire({
			title: "Sucesso!",
			text: "Dados salvos com sucesso.",
			icon: "success",
			confirmButtonText: "Ok"
		});

		this.props.history.push("/dashboard/apikeys");
	};
	handleChange = e => {
		const { name, value } = e.target;
		this.setState({
			[name]: value
		});
	};

	formIsValid = () => {
		return (
			this.state.service &&
			this.state.service.length > 0 &&
			this.state.key &&
			this.state.key.length > 0 &&
			this.state.expiresAt &&
			this.state.expiresAt.length > 0
		);
	};

	onCleanForm = async () => {
		if (this.props.match.params.id) {
			this.setState({ isLoading: true });

			try {
				await this.loadData(this.props.match.params.id);
			} catch (e) {
				await Swal.fire(
					"Erro",
					"Problema ao reverter as alterações, tente mais tarde",
					"error"
				);
			}

			this.setState({ isLoading: false });
		} else {
			this.setState({
				...initialState,
				resetInput: true
			});
		}
	};

	render() {
		if (this.state.isEditing) {
			window.setPageTitle("Atualizar Api Key - Admin");
		} else {
			window.setPageTitle("Cadastro Api Key - Admin");
		}

		const { service, isLoading, isEditing, key, expiresAt } = this.state;

		return (
			<>
				<Loading isLoading={isLoading} />
				<AdminTitle title="Dados da Api Key" disableHeader />
				<Card className="mt-4">
					<Box>
						<StyledCardBody>
							<Grid container>
								<Grid
									item
									xs={12}
									sm={12}
									style={{
										marginBottom: "30px"
									}}
								>
									<Form style={{ flex: "1" }}>
										{/* row 1 */}
										<Form.Row>
											{/* Serviço */}
											<Form.Group as={Col} lg="6" xs="12">
												<InputField
													type="text"
													name="service"
													label="Serviço"
													placeholder="Digite o nome do serviço"
													value={service}
													onChange={this.handleChange}
													isInvalid={service && !IsValidName(service)}
												/>
											</Form.Group>
											{/* Data de Expiração */}
											<Form.Group as={Col} lg="4" xs="12">
												<InputField
													type="date"
													name="expiresAt"
													label="Data de Expiração"
													placeholder="Digite a data de expiração"
													value={moment(expiresAt, dateTimeFormat).toDate()}
													onChange={this.handleChange}
													disabled={this.state.isIndefinite}
												/>
											</Form.Group>
											{/* Toggle para data indeterminada */}
											<Form.Group
												as={Col}
												lg="2"
												xs="12"
												style={{
													border: this.state.isIndefinite
														? "1px solid #777"
														: "1px solid #ccc",
													height: "100%",
													borderRadius: "4px"
												}}
											>
												<div
													style={{
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														justifyContent: "space-between"
													}}
												>
													<small
														style={{ textAlign: "center", marginBottom: "5px" }}
													>
														{" "}
														{/* Texto centralizado */}
														Expiração indeterminada
													</small>

													<IconButton
														color="primary"
														title="Data indeterminada para expiração"
														style={{ padding: "0", height: "10px" }}
														onClick={() => {
															this.setState({
																isIndefinite: !this.state.isIndefinite
															});
														}}
													>
														<Icon
															style={{
																color: this.state.isIndefinite
																	? "#9036F7"
																	: "#ccc",
																width: "30px"
															}}
														>
															{this.state.isIndefinite ? (
																<img src={toggleOnIcon} alt="toggle on" />
															) : (
																<img src={toggleOffIcon} alt="toggle off" />
															)}
														</Icon>
													</IconButton>
												</div>
											</Form.Group>
										</Form.Row>
										<Form.Row
											style={{
												display: "flex",
												flexDirection: "column",
												justifyContent: "space-between",
												marginBottom: "20px"
											}}
										>
											{/* Chave */}
											<Form.Group
												as={Col}
												lg={isEditing ? "11" : "10"}
												xs={isEditing ? "11" : "10"}
											>
												<InputField
													type="text"
													as="textarea"
													name="key"
													label="Chave"
													placeholder="Digite a chave"
													value={key}
													onChange={this.handleChange}
													isInvalid={key && !IsValidName(key)}
													disabled={true}
													rows={2}
													height="100%"
												/>
											</Form.Group>
											{/* //button for generate random key */}
											<Form.Group
												as={Col}
												lg={isEditing ? "1" : "2"}
												xs={isEditing ? "1" : "2"}
												style={{
													position: "relative",
													display: "flex",
													gap: "10px",
													justifyContent: "center",
													alignItems: "center",
													marginTop: "10px"
												}}
											>
												<Button
													style={{
														display: isEditing ? "none" : "block",
														whiteSpace: "nowrap",
														width: "100%"
													}}
													variant="primary"
													color="#9036F7"
													onClick={this.generateKey}
													type="button"
												>
													Gerar Chave
												</Button>

												<Button
													variant="primary"
													style={{ maxWidth: "45px" }}
													color="#9036F7"
													onClick={() => {
														navigator.clipboard.writeText(this.state.key);
														this.toggleTooltip();
													}}
													type="button"
													title="Copiar chave para área de transferência"
												>
													<SvgIcon
														component={copyIcon}
														fill="#fff"
														title="Copiar chave para área de transferência"
													/>
												</Button>

												{this.state.showTooltip && (
													<div
														style={{
															position: "absolute",
															top: "-20px",
															right: "0",
															background: "#333",
															color: "#fff",
															padding: "5px",
															borderRadius: "3px"
														}}
													>
														Chave copiada com sucesso.
													</div>
												)}
											</Form.Group>
										</Form.Row>
									</Form>
								</Grid>
							</Grid>
						</StyledCardBody>
					</Box>
				</Card>
				<FormActions
					module="apikeys"
					isEdit={isEditing}
					formIsValid={this.formIsValid()}
					onCleanForm={this.onCleanForm}
					onSubmit={this.submit}
					hideReload
				/>
			</>
		);
	}
}
